import { Pipe, PipeTransform } from '@angular/core';
import { GfTranslateService } from '../../services/core.translate.service';

@Pipe({ name: 'translate' })
export class TranslatePipe implements PipeTransform {
    constructor(private translateService: GfTranslateService){};
    
    transform(val: string, params?: any): string {
        return this.translateService.translate(val, params);
    }
}
